import moment from 'moment';

// Booking times are stored with the company's offset for their date: show that wall clock, not the computer's.
export function companyWallClock ( time : string, format : string ) : string {
  return moment.parseZone(time).format(format);
}
